import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

export function useCityCatalog() {
  const navigate = useNavigate();

  const [cities, setCities] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Devolve a promise (resolvida com a lista) para quem precisa agir logo após o refetch,
  // como o cadastro rápido de cidade dentro do formulário do paciente.
  const fetchCities = useCallback(() => {
    setLoading(true);
    return quarkusApi
      .get('/city-catalog', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        setCities(returnFromApi.data);
        return returnFromApi.data;
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => {
    fetchCities();
  }, [fetchCities]);

  return { cities, isLoading, error, refetch: fetchCities };
}
